export const TODO_GROUP_SLUG = "todo";
export const THIS_SESSION_GROUP_SLUG = "in-session";
export const COMPLETED_GROUP_SLUG = "completed";
export const UNSCHEDULED_TODO_GROUP_SLUG = "unscheduled-todo"; // this is so we can find the ones that aren't scheduled

export enum TaskStatus {
  TODO = TODO_GROUP_SLUG,
  THIS_SESSION = THIS_SESSION_GROUP_SLUG,
  UNSCHEDULED_TODO = UNSCHEDULED_TODO_GROUP_SLUG,
  COMPLETED = COMPLETED_GROUP_SLUG,
}

export type Task = {
  id: string;
  name: string;
  description?: string;
  category?: string;
  estimatedTime?: number;
  timeSpent?: number;
  /**
   * A day. Over JSON it is a string (`2026-10-24T00:00:00.000Z`, or
   * `2026-10-24` from an edit) — read it with `taskDueDay`, never through a
   * time zone.
   */
  dueDate?: Date | string;
  completedAt?: Date;
  orderIndex?: number;
  externalServiceName?: string;
  externalTaskId?: string;
  externalTaskUrl?: string;
  isActiveTask?: boolean;
  isOptimistic?: boolean; // Add optional optimistic flag
  isRecurring?: boolean;
};

export type ExternalTaskSource = "linear" | "todoist" | string;

export type ExternalTaskService = {
  source: ExternalTaskSource;
  id: string;
};
